export enum conditionsValues {
  /** Valeur spéciale permettant d'obtenir des valeurs de conditions nulles ou vides */
  Empty = "EMPTY",
}
